import { useEffect, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';

import usePhone from '../hooks/usePhone';
import useUserIdentity from '../hooks/useUserIdentity';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Divider from '@mui/material/Divider';
import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionSummary from '@mui/joy/AccordionSummary';
import AccordionGroup from '@mui/joy/AccordionGroup';
import CollabCallItem from './CollabCallItem';

// import { CollabProps } from '../stores/collab_store';
import { getIcon, pluralize } from 'utils/misc';

const CollabWorkSpaceSidebarCallLog = observer(({associated_type, associated_uuid}: {associated_type: string, associated_uuid: string}) => {
    const { getCallsByAssociation, fetchCallsByAssociation } = usePhone();
    const { currentIdentity } = useUserIdentity();
    const [loaded, setLoaded] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const PhoneIcon = getIcon('PhoneForwardedOutlined');

    const collabCalls = getCallsByAssociation(associated_type, associated_uuid);
    const loader = useCallback(() => {
        if(associated_type && associated_uuid && currentIdentity.key) {
            setLoaded(true);
            fetchCallsByAssociation(associated_type, associated_uuid, currentIdentity.key);
        }
    }, [fetchCallsByAssociation, associated_type, associated_uuid, currentIdentity.key, setLoaded]);

    useEffect(() => {
        if(!loaded) {
            loader();
        }
    }, [loader, loaded, setLoaded]);

    return (
        <AccordionGroup size="lg">
            <Accordion
                expanded={expanded}
                onChange={() => setExpanded(!expanded)}
            >
                <AccordionSummary>
                    <PhoneIcon />
                    <Typography level="body-sm">
                        { pluralize(collabCalls?.length, 'Call') }
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack
                        spacing={1}
                        divider={<Divider />}
                    >
                        <Stack
                            justifyContent="center"
                            alignItems="center"
                            direction="row"
                            spacing={1}>

                        </Stack>
                    {collabCalls &&
                        collabCalls.map((c) =>
                            <CollabCallItem key={c.key} call={c} />
                        )
                    }

                    </Stack>
                </AccordionDetails>
            </Accordion>
        </AccordionGroup>
    );
});

export default CollabWorkSpaceSidebarCallLog;
